import React from 'react';

import ROUTES from '@/common/routes';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { ScheduledContributionSummary } from '@/modules/employer/components/Contributions/ScheduledContribution';

import PageScrollVisibleWrapper from './PageScrollVisibleWrapper';

const ScheduledContributionEditPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.CONTRIBUTIONS,
      title: 'Contributions',
    },
    {
      route: ROUTES.SCHEDULED_CONTRIBUTION_SUMMARY,
      title: 'Scheduled Contributions',
    },
  ]);
  return (
    <PageScrollVisibleWrapper>
      <Topbar />

      <ScheduledContributionSummary isEditMode />
    </PageScrollVisibleWrapper>
  );
};

export default ScheduledContributionEditPage;
